(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Story-Hero-Banner"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('story-hero-creative-v2')) {
 customElements.define('story-hero-creative-v2', class extends HTMLElement {
  connectedCallback() {
   if(this.controller) return;
   this.controller=new AbortController();
   const options={signal:this.controller.signal};
   this.updateReveal=()=>{
    const stage=this.querySelector('.mission-stage');
    const content=this.querySelector('.story-hero__content');
    if(!stage||!content)return;
    const top=parseFloat(getComputedStyle(this).getPropertyValue('--mission-top'))||0;
    
    const distance=(parseFloat(getComputedStyle(this).getPropertyValue('--mission-distance'))||0)*window.innerHeight/100;
    const threshold=distance>0?Math.max(1,distance*.15):48;
    if(top-stage.getBoundingClientRect().top>=threshold)this.hasRevealed=true;
    const visible=matchMedia('(max-width:749px)').matches||this.dataset.editor==='true'||this.hasAttribute('data-editor-selected')||this.hasRevealed===true;
    this.dataset.textVisible=String(visible);
    content.inert=!visible;
    content.setAttribute('aria-hidden',String(!visible));
    this.setAttribute('data-reveal-ready','');
   };
   this.onScroll=()=>{
    if(this.scrollFrame)return;
    this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=null;this.updateReveal();});
   };
   this.refresh=()=>{
    if(this.frame)return;
    this.frame=requestAnimationFrame(()=>{
     this.frame=null;
     if(!this.isConnected)return;
     this.style.removeProperty('--hero-viewport-width');
     this.style.removeProperty('--hero-left-offset');
     const left=this.getBoundingClientRect().left;
     const width=document.documentElement.clientWidth;
     if(width>0){this.style.setProperty('--hero-viewport-width',width+'px');this.style.setProperty('--hero-left-offset',-left+'px');}
     this.updateReveal();
    });
   };
   window.addEventListener('scroll',this.onScroll,{...options,passive:true});
   window.addEventListener('resize',this.refresh,options);
   window.addEventListener('pageshow',this.refresh,options);
   this.addEventListener('shopify:block:select',()=>{this.setAttribute('data-editor-selected','');this.updateReveal();},options);
   this.addEventListener('shopify:block:deselect',()=>{this.removeAttribute('data-editor-selected');this.updateReveal();},options);
   if(typeof ResizeObserver!=='undefined'){
    this.observer=new ResizeObserver(this.refresh);
    this.observer.observe(document.documentElement);
    if(this.parentElement)this.observer.observe(this.parentElement);
   }
   this.updateReveal();this.refresh();
  }
  disconnectedCallback(){
   this.controller?.abort();this.observer?.disconnect();
   if(this.frame)cancelAnimationFrame(this.frame);
   if(this.scrollFrame)cancelAnimationFrame(this.scrollFrame);
   this.controller=null;this.observer=null;this.frame=null;this.scrollFrame=null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
(() => {
  function updateBreadcrumbs(event) {
    const detail = event && event.detail;
    const roots = Array.from(document.querySelectorAll('.dt-help-center'));
    const help = (detail && document.getElementById(detail.sectionId)) || roots.find(root => root.querySelector('[data-category-panel].is-active:not([hidden])'));
    const panel = help && (help.querySelector('[data-category-panel].is-active:not([hidden])') || help.querySelector('[data-category-panel]:not([hidden])'));
    const heading = panel && panel.querySelector('.dt-help-center__heading');
    const label = (heading && heading.textContent.trim()) || (panel && panel.getAttribute('aria-label'));
    document.querySelectorAll('[data-dt-breadcrumb-current]').forEach(element => {
      const text = label || element.getAttribute('data-dt-page-label') || '';
      if (element.textContent !== text) element.textContent = text;
    });
  }
  document.addEventListener('dt:help-category-change', updateBreadcrumbs);
  document.addEventListener('shopify:section:load', updateBreadcrumbs);
  document.addEventListener('shopify:block:select', () => queueMicrotask(updateBreadcrumbs));
  window.addEventListener('hashchange', () => queueMicrotask(updateBreadcrumbs));
  window.addEventListener('popstate', () => queueMicrotask(updateBreadcrumbs));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateBreadcrumbs, { once: true });
  else updateBreadcrumbs();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cable-management-trio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-task-light')) {
    customElements.define('ct-task-light', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.initialize()); }
      initialize() {
        if (this.ready) return;
        this.ready = true;
        this.selected = '';
        this.buttons = Array.from(this.querySelectorAll('button[data-kelvin]'));
        this.buttons.forEach(button => {
          const value = button.dataset.kelvin;
          button.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'touch') this.show(value);
          });
          button.addEventListener('focus', () => this.show(value));
          button.addEventListener('click', () => {
            this.selected = this.selected === value ? '' : value;
            this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.kelvin === this.selected)));
            this.show(this.selected);
          });
        });
        this.addEventListener('pointerleave', () => this.show(this.selected));
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.show(this.selected);
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.selected = '';
            this.buttons.forEach(item => item.setAttribute('aria-pressed', 'false'));
            this.show('');
          }
        });
      }
      show(value) {
        if (value) this.dataset.active = value;
        else delete this.dataset.active;
      }
    });
  }

  if (!customElements.get('ct-power-ports')) {
    customElements.define('ct-power-ports', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.initialize()); }
      initialize() {
        if (this.ready) return;
        this.ready = true;
        this.selected = '';
        this.buttons = Array.from(this.querySelectorAll('button[data-port]'));
        this.buttons.forEach(button => {
          const value = button.dataset.port;
          button.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'touch') this.show(value);
          });
          button.addEventListener('focus', () => this.show(value));
          button.addEventListener('click', () => {
            this.selected = this.selected === value ? '' : value;
            this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.port === this.selected)));
            this.show(this.selected);
          });
        });
        this.addEventListener('pointerleave', () => this.show(this.selected));
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.show(this.selected);
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.selected = '';
            this.buttons.forEach(item => item.setAttribute('aria-pressed', 'false'));
            this.show('');
          }
        });
      }
      show(value) {
        if (value) this.dataset.active = value;
        else delete this.dataset.active;
      }
    });
  }


  if (!customElements.get('ct-wireless-demo')) {
    customElements.define('ct-wireless-demo', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.initialize()); }
      initialize() {
        if (this.ready || !this.isConnected) return;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.ready = true;
        this.devices = ['phone', 'watch', 'earbuds'];
        this.labels = ['iPhone 充电连接成功', '智能手表充电连接成功', '无线耳机盒充电连接成功'];
        this.index = -1;
        this.pinned = false;
        this.button.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch') this.start();
        });
        this.button.addEventListener('focus', () => {
          if (!this.pinned && this.index < 0) this.show(0);
        });
        this.button.addEventListener('click', () => {
          this.stop();
          if (!this.pinned) { this.pinned = true; this.show(0); }
          else if (this.index < 2) this.show(this.index + 1);
          else { this.pinned = false; this.reset(); }
          this.button.setAttribute('aria-pressed', String(this.pinned));
        });
        this.addEventListener('pointerleave', () => {
          this.stop();
          if (!this.pinned) this.reset();
        });
        this.button.addEventListener('blur', () => {
          this.stop();
          if (!this.pinned) this.reset();
        });
        this.button.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.stop(); this.pinned = false; this.reset();
            this.button.setAttribute('aria-pressed', 'false');
          }
        });
      }
      start() {
        if (this.pinned) return;
        this.stop(); this.show(0);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const interval = Math.max(1000, (Number(this.dataset.interval) || 2.4) * 1000);
        this.timer = window.setInterval(() => this.show((this.index + 1) % 3), interval);
      }
      stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
      show(index) {
        this.index = index;
        this.dataset.device = this.devices[index];
        this.querySelector('[data-charge-status]').textContent = this.labels[index];
      }
      reset() {
        this.index = -1;
        delete this.dataset.device;
        this.querySelector('[data-charge-status]').textContent = '';
      }
      disconnectedCallback() {
        this.stop();
        if (this.ready) {
          this.pinned = false; this.reset();
          this.button.setAttribute('aria-pressed', 'false');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-desk-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desk-video-showcase')) {
    customElements.define('desk-video-showcase', class extends HTMLElement {
      connectedCallback() {
        this.playVideo = () => {
          const video = this.querySelector('video.dvs__video');
          if (!video) return;
          video.muted = true;
          video.defaultMuted = true;
          const promise = video.play();
          if (promise && typeof promise.catch === 'function') {
            promise.catch(() => {});
          }
        };

        this.playVideo();
        this.onVisibilityChange = () => {
          if (!document.hidden) this.playVideo();
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desk-image-compare-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desk-compare-vertical')) {
    customElements.define('desk-compare-vertical', class extends HTMLElement {
      connectedCallback() {
        this.mountFrame = requestAnimationFrame(() => this.mount());
      }
      mount() {
        if (!this.isConnected || this.controller) return;
        this.stage = this.querySelector('[data-dcp-stage]');
        this.range = this.querySelector('[data-dcp-range]');
        if (!this.stage || !this.range) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.initial = Math.max(0, Math.min(100, Number(this.dataset.start) || 0));
        this.range.disabled = false;
        this.setPosition(this.initial);
        this.setAttribute('data-ready', '');
        this.range.addEventListener('input', () => { this.stopDemo(); this.setPosition(this.range.value); }, options);
        this.range.addEventListener('keydown', event => {
          this.stopDemo();
          const current = Number(this.range.value);
          const keys = { ArrowUp: current - 1, ArrowDown: current + 1, ArrowLeft: current - 1, ArrowRight: current + 1, PageUp: current - 10, PageDown: current + 10, Home: 0, End: 100 };
          if (Object.prototype.hasOwnProperty.call(keys, event.key)) {
            event.preventDefault();
            this.setPosition(keys[event.key]);
          }
        }, options);
        this.range.addEventListener('focus', () => this.stopDemo(), options);
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || event.target.closest('[data-dcp-text]')) return;
          this.stopDemo();
          this.pointer = event.pointerId;
          this.stage.setPointerCapture(event.pointerId);
          this.range.focus({ preventScroll: true });
          this.moveTo(event.clientY);
        }, options);
        this.stage.addEventListener('pointermove', event => {
          if (this.pointer === event.pointerId) this.moveTo(event.clientY);
        }, options);
        const release = event => {
          if (this.pointer !== event.pointerId) return;
          this.pointer = null;
          if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        };
        this.stage.addEventListener('pointerup', release, options);
        this.stage.addEventListener('pointercancel', release, options);
        this.stage.addEventListener('lostpointercapture', () => { this.pointer = null; }, options);
        this.stage.addEventListener('dblclick', event => {
          if (event.target.closest('[data-dcp-text]')) return;
          this.stopDemo(); this.setPosition(this.initial);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) this.stopDemo();
        }, options);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.stopDemo(); }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stopDemo(); }, options);
        if (this.dataset.demo === 'true' && this.dataset.editor !== 'true' && !this.motion.matches && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.animateDemo();
            }
          }, { threshold: 0.35 });
          this.observer.observe(this.stage);
        }
      }
      setPosition(value) {
        const position = Math.max(0, Math.min(100, Number(value) || 0));
        this.style.setProperty('--dcp-split', position + '%');
        this.range.value = String(Math.round(position));
        this.range.setAttribute('aria-valuetext', Math.round(position) + '%');
      }
      moveTo(clientY) {
        const bounds = this.stage.getBoundingClientRect();
        if (bounds.height) this.setPosition((clientY - bounds.top) / bounds.height * 100);
      }
      stopDemo() {
        this.interacted = true;
        cancelAnimationFrame(this.demoFrame);
        if (this.observer) this.observer.disconnect();
      }
      animateDemo() {
        if (this.interacted || this.motion.matches || !this.isConnected) return;
        const points = [this.initial, Math.min(90, this.initial + 25), Math.max(10, this.initial - 25), this.initial];
        const duration = Math.max(1000, Math.min(4000, Number(this.dataset.duration) * 1000 || 3000));
        let start;
        const tick = time => {
          if (this.interacted || !this.isConnected) return;
          if (start === undefined) start = time;
          const progress = Math.min(1, (time - start) / duration);
          const segment = Math.min(2, Math.floor(progress * 3));
          const t = progress === 1 ? 1 : progress * 3 - segment;
          const ease = (1 - Math.cos(Math.PI * t)) / 2;
          this.setPosition(points[segment] + (points[segment + 1] - points[segment]) * ease);
          if (progress < 1) this.demoFrame = requestAnimationFrame(tick);
        };
        this.demoFrame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.mountFrame);
        this.stopDemo();
        if (this.controller) this.controller.abort();
        this.controller = null;
        this.pointer = null;
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domitree-desk-morph-cta"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('domitree-desk-cta-edge'))customElements.define('domitree-desk-cta-edge',class extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;this.controller=new AbortController();const opts={signal:this.controller.signal};
  this.fitWidth=()=>{
   this.style.setProperty('--dc-offset','0px');
   const left=this.getBoundingClientRect().left;
   this.style.setProperty('--dc-viewport',document.documentElement.clientWidth+'px');
   this.style.setProperty('--dc-offset',(-left)+'px');
  };
  this.scheduleFit=()=>{cancelAnimationFrame(this.fitFrame);this.fitFrame=requestAnimationFrame(this.fitWidth);};
  this.fitWidth();window.addEventListener('resize',this.scheduleFit,opts);
  window.addEventListener('pageshow',this.scheduleFit,opts);
  if(typeof ResizeObserver!=='undefined'){this.widthObserver=new ResizeObserver(this.scheduleFit);this.widthObserver.observe(document.documentElement);if(this.parentElement)this.widthObserver.observe(this.parentElement);}
  this.addEventListener('shopify:block:select',()=>this.setAttribute('data-editing',''),opts);
  this.addEventListener('shopify:block:deselect',()=>this.removeAttribute('data-editing'),opts);
  this.addEventListener('focusin',()=>this.setAttribute('data-visible',''),opts);
  if(this.dataset.reveal==='true'&&!matchMedia('(prefers-reduced-motion:reduce)').matches&&typeof IntersectionObserver!=='undefined'){
   const box=this.getBoundingClientRect();
   if(box.top<innerHeight&&box.bottom>0){this.setAttribute('data-visible','');}
   else{this.setAttribute('data-enter-ready','');this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.setAttribute('data-visible','');this.observer.disconnect();}},{threshold:0,rootMargin:'0px 0px -24px 0px'});this.observer.observe(this);}
  }
 }
 disconnectedCallback(){cancelAnimationFrame(this.fitFrame);this.widthObserver?.disconnect();this.controller?.abort();this.observer?.disconnect();this.controller=null;this.observer=null;this.removeAttribute('data-enter-ready');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domitree-kickstarter-proof-stats"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('domitree-proof-motion')){
 customElements.define('domitree-proof-motion',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.animations=[];this.timers=[];this.played=false;
   const targets=[this.querySelector('.dt-kickstarter-proof__heading-wrap'),...this.querySelectorAll('.dt-kickstarter-proof__stat')].filter(Boolean);
   this.finish=()=>{this.animations.forEach(a=>a.cancel());this.animations=[];this.observer?.disconnect()};
   const reveal=()=>{
    if(this.played)return;this.played=true;
    if(this.dataset.motion!=='true'||this.reduced.matches||window.Shopify?.designMode)return;
    targets.forEach((el,i)=>{if(typeof el.animate!=='function')return;const a=el.animate([{opacity:.25,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:Number(this.dataset.duration)||700,delay:i*80,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});this.animations.push(a)});
   };
   if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){reveal();this.observer.disconnect()}},{threshold:.12});this.observer.observe(this)}else reveal();
   this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.finish()},{signal});
   this.addEventListener('pointermove',e=>{
    if(e.pointerType!=='mouse'||this.dataset.hover!=='true'||this.reduced.matches)return;
    const card=e.target.closest('.dt-kickstarter-proof__stat');if(!card)return;
    this.point={card,x:e.clientX,y:e.clientY};if(this.frame)return;
    this.frame=requestAnimationFrame(()=>{this.frame=0;const {card,x,y}=this.point;const r=card.getBoundingClientRect();card.style.setProperty('--dt-pointer-x',((x-r.left)/r.width*100)+'%');card.style.setProperty('--dt-pointer-y',((y-r.top)/r.height*100)+'%')});
   },{passive:true,signal});
   this.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'||this.dataset.hover!=='true')return;const card=e.target.closest('.dt-kickstarter-proof__stat');if(!card)return;card.classList.add('is-touch')},{passive:true,signal});
   const release=()=>this.querySelectorAll('.is-touch').forEach(card=>{const timer=setTimeout(()=>card.classList.remove('is-touch'),220);this.timers.push(timer)});
   window.addEventListener('pointerup',release,{passive:true,signal});window.addEventListener('pointercancel',release,{passive:true,signal});
   this.addEventListener('shopify:block:select',()=>this.finish(),{signal});
  }
  disconnectedCallback(){this.abort?.abort();this.finish?.();cancelAnimationFrame(this.frame);this.frame=0;this.timers?.forEach(clearTimeout)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domitree-media-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('domitree-height-video-v4')) {
  customElements.define('domitree-height-video-v4', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true' || this.abort) return;

      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };

      this.grid = this.querySelector('.dms__grid');
      this.compare = this.querySelector('.dh-comparison');
      this.wordmark = this.querySelector('.dh-wordmark');
      this.compareHome = document.createComment('Comparison desktop position');
      this.compare.before(this.compareHome);
      this.storyWrap = this.querySelector('.dh-story-wrap');
      this.compact = window.innerWidth < 990;
      this.cards = [...this.querySelectorAll('.dh-stack > .dms__media')];
      this.motion = matchMedia('(prefers-reduced-motion: no-preference)');

      if (!this.grid || !this.compare || !this.cards.length) return;

      // In static layout, keep the wordmark and its reflection visible in normal
      // document flow. The next Shopify section entering the viewport is not a
      // reason to hide this branding; it follows the comparison cards naturally.
      this.updateStaticWordmark = () => {
        if (!this.wordmark || this.hasAttribute('data-pinned')) return;
        this.wordmark.classList.remove('is-pending', 'is-hidden');
      };

      this.setupVideos(opts);
      this.setupSwipeControls(opts);
      const comparisonRail = this.querySelector('.dh-comparison-rail');
      comparisonRail?.addEventListener('keydown', event => {
        if (window.innerWidth >= 990 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const width = comparisonRail.clientWidth + 16;
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? comparisonRail.scrollWidth : comparisonRail.scrollLeft + (event.key === 'ArrowRight' ? width : -width);
        comparisonRail.scrollTo({left,behavior:this.motion.matches?'smooth':'auto'});
      }, opts);

      this.render = (progressValue) => {
        if (!this.hasAttribute('data-pinned')) return;

        const p = Number.isFinite(progressValue)
          ? Math.max(0, progressValue)
          : Math.max(0, (window.scrollY - this.start) / this.step);
        const clamp = value => Math.max(0, Math.min(1, value));
        let active = 0;

        this.cards.forEach((card, index) => {
          if (index === 0) {
            card.style.setProperty('--dh-y', '0%');
            card.style.setProperty('--dh-visible', 'visible');
            return;
          }

          const progress = clamp((p - (index - 1) - 0.2) / 0.8);
          card.style.setProperty('--dh-y', `${110 * (1 - progress)}%`);
          card.style.setProperty('--dh-visible', progress > 0 ? 'visible' : 'hidden');

          if (progress >= 0.55) active = index;
        });

        // After the third card settles, the comparison screen slides up
        // from below and covers the pinned card-and-copy screen.
        const compareStart = this.cards.length - 1 + 0.15;
        const compareProgress = this.compact ? 0 : clamp((p - compareStart) / 0.85);
        const comparisonCovered = compareProgress >= 0.5;
        const comparisonReady = compareProgress >= 0.98;

        this.style.setProperty('--dh-compare-y', `${100 * (1 - compareProgress)}%`);
        this.style.setProperty('--dh-compare-visible', compareProgress > 0 ? 'visible' : 'hidden');

        // Reveal the wordmark after the comparison panel has mostly settled.
        // Never hide it just because the following Shopify section enters the viewport:
        // the wordmark remains in the comparison layout and the next section follows it.
        if (this.wordmark) {
          this.wordmark.classList.remove('is-pending', 'is-hidden');
          }

        if (this.grid.inert !== comparisonCovered) this.grid.inert = comparisonCovered;
        const gridHidden = String(comparisonCovered);
        if (this.grid.getAttribute('aria-hidden') !== gridHidden) {
          this.grid.setAttribute('aria-hidden', gridHidden);
        }

        const compareInert = this.compact ? false : !comparisonReady;
        if (this.compare.inert !== compareInert) this.compare.inert = compareInert;
        const compareHidden = String(compareInert);
        if (this.compare.getAttribute('aria-hidden') !== compareHidden) {
          this.compare.setAttribute('aria-hidden', compareHidden);
        }

        const nextVideoActive = comparisonCovered ? -1 : active;
        if (this.videoActive !== nextVideoActive) {
          this.videoActive = nextVideoActive;
          this.syncVideos();
        }

        this.cards.forEach((card, index) => {
          const isActive = index === active && !comparisonCovered;
          const cardInert = !isActive;
          if (card.inert !== cardInert) card.inert = cardInert;
          const cardHidden = String(cardInert);
          if (card.getAttribute('aria-hidden') !== cardHidden) {
            card.setAttribute('aria-hidden', cardHidden);
          }

          if (!isActive) {
            card.querySelectorAll('video').forEach(video => {
              if (!video.paused) video.pause();
            });
          }
        });
      };

      this.animate = (timestamp) => {
        this.frame = null;
        if (!this.hasAttribute('data-pinned')) return;

        const targetProgress = Math.max(0, (window.scrollY - this.start) / this.step);
        if (!Number.isFinite(this.currentProgress)) this.currentProgress = targetProgress;

        const elapsed = this.lastFrameTime ? Math.min(50, timestamp - this.lastFrameTime) : 16.67;
        this.lastFrameTime = timestamp;
        const smoothing = 1 - Math.exp(-elapsed / 58);
        this.currentProgress += (targetProgress - this.currentProgress) * smoothing;

        if (Math.abs(targetProgress - this.currentProgress) < 0.001) {
          this.currentProgress = targetProgress;
        }

        this.render(this.currentProgress);

        if (Math.abs(targetProgress - this.currentProgress) >= 0.001) {
          this.frame = requestAnimationFrame(this.animate);
        } else {
          this.lastFrameTime = 0;
        }
      };

      this.measure = () => {
        if (this.frame) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }
        this.lastFrameTime = 0;
        this.currentProgress = null;

        const mobile = window.innerWidth < 990;
        this.compact = mobile;
        if (mobile) {
          if (this.compare.parentElement !== this) this.storyWrap.after(this.compare);
        } else if (this.compare.previousSibling !== this.compareHome) {
          this.compareHome.after(this.compare);
        }
        const stickyHeaders = [...document.querySelectorAll('sticky-header, .shopify-section-header, header[role="banner"]')];
        const headerHeight = Math.max(0, ...stickyHeaders.map(header => {
          const position = getComputedStyle(header).position;
          const box = header.getBoundingClientRect();
          return (position === 'fixed' || position === 'sticky') && box.height < window.innerHeight * .3 ? box.height : 0;
        }));
        const stickyTop = Math.max(mobile ? 12 : 24, headerHeight + 12);
        const content = this.querySelector('.dms__content');
        const clearPinnedStyles = () => {
          this.removeAttribute('data-pinned');
          [
            '--dh-height', '--dh-distance', '--dh-top', '--dh-compare-y', '--dh-compare-visible'
          ].forEach(property => this.style.removeProperty(property));
        };
        const restoreStaticLayout = () => {
          clearPinnedStyles();
          this.grid.inert = false;
          this.grid.removeAttribute('aria-hidden');
          this.compare.inert = false;
          this.compare.removeAttribute('aria-hidden');
          this.cards.forEach(card => {
            card.inert = false;
            card.removeAttribute('aria-hidden');
            card.style.removeProperty('--dh-y');
            card.style.removeProperty('--dh-visible');
          });
          this.videoActive = 0;
          this.syncVideos();
          this.updateStaticWordmark();
        };

        clearPinnedStyles();

        const availableHeight = window.innerHeight - stickyTop - 24;
        const configuredStageHeight = Number(this.dataset.stageHeight) || 560;
        const contentHeight = content ? content.offsetHeight : 0;
        const mobileGap = parseFloat(getComputedStyle(this.grid).rowGap) || 0;
        const mediaWidth = this.grid.getBoundingClientRect().width;
        const ratioValue = getComputedStyle(this).getPropertyValue('--dms-ratio').trim();
        const ratioParts = ratioValue.split('/').map(Number);
        const mediaRatio = ratioParts.length === 2 && ratioParts.every(n => n > 0) ? ratioParts[0] / ratioParts[1] : 4 / 3;
        const naturalMediaHeight = mediaWidth / mediaRatio;
        const mediaHeight = mobile ? mediaWidth : Math.min(naturalMediaHeight, Math.max(180, availableHeight - contentHeight - mobileGap));
        const stageHeight = mobile ? contentHeight + mobileGap + mediaHeight : Math.min(availableHeight, configuredStageHeight);
        this.style.setProperty('--dh-mobile-media-height', mediaHeight + 'px');
        const comparisonFigures = [...this.compare.querySelectorAll('.dh-figure')];
        const canPin =
          this.motion.matches &&
          this.cards.length === 3 &&
          comparisonFigures.length === 3 &&
          stageHeight >= (mobile ? 180 : 360) &&
          (!mobile || stageHeight <= availableHeight + 1) &&
          contentHeight + (mobile ? 180 + (parseFloat(getComputedStyle(this.grid).rowGap) || 0) : 0) <= stageHeight;

        if (!canPin) {
          restoreStaticLayout();
          return;
        }

        this.step = mobile
          ? Math.max(280, Math.min(600, availableHeight * .85))
          : Math.max(200, Number(this.dataset.step) || 600);
        const sectionPaddingTop = parseFloat(getComputedStyle(this).paddingTop) || 0;

        this.start = this.getBoundingClientRect().top + window.scrollY + sectionPaddingTop - stickyTop;
        this.style.setProperty('--dh-top', `${stickyTop}px`);
        this.style.setProperty('--dh-height', `${stageHeight}px`);
        // Two card changes, one comparison transition, and enough scroll distance
        // to keep the comparison screen visible before the section exits.
        this.style.setProperty('--dh-distance', `${this.step * (this.cards.length - 1 + (mobile ? 0 : 2.25))}px`);
        this.setAttribute('data-pinned', '');

        // The comparison panel includes the wordmark now. Keep the image row entirely
        // inside the pinned stage, and only pin when the wordmark's top is also visible.
        // The logo itself may extend below the viewport like the reference layout, but
        // it remains below the cards and is never pulled over them.
        const compareStyles = getComputedStyle(this.compare);
        const comparePaddingTop = parseFloat(compareStyles.paddingTop) || 0;
        const comparePaddingBottom = parseFloat(compareStyles.paddingBottom) || 0;
        const rowGap = parseFloat(compareStyles.rowGap) || 0;
        const wordmarkStyles = this.wordmark ? getComputedStyle(this.wordmark) : null;
        const wordmarkMarginTop = wordmarkStyles ? parseFloat(wordmarkStyles.marginTop) || 0 : 0;
        const maxFigureHeight = Math.max(0, ...comparisonFigures.map(figure => figure.offsetHeight));
        const wordmarkTopInViewport = stickyTop + comparePaddingTop + maxFigureHeight + rowGap + wordmarkMarginTop;
        const enoughRoomForCards = comparePaddingTop + maxFigureHeight + comparePaddingBottom <= stageHeight + 1;
        const enoughRoomForWordmark = wordmarkTopInViewport < window.innerHeight - 40;

        if (!mobile && (!enoughRoomForCards || !enoughRoomForWordmark)) {
          restoreStaticLayout();
          return;
        }

        const videoBounds = this.grid.getBoundingClientRect();
        this.videoInView = videoBounds.bottom > stickyTop && videoBounds.top < window.innerHeight;
        this.currentProgress = Math.max(0, (window.scrollY - this.start) / this.step);
        this.render(this.currentProgress);
      };
      this.queue = () => {
        if (!this.hasAttribute('data-pinned')) {
          if (this.staticFrame) return;
          this.staticFrame = requestAnimationFrame(() => {
            this.staticFrame = null;
            this.updateStaticWordmark();
          });
          return;
        }

        if (this.frame) return;
        this.frame = requestAnimationFrame(this.animate);
      };

      this.resize = () => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(this.measure);
      };

      window.addEventListener('scroll', this.queue, { ...opts, passive: true });
      window.addEventListener('resize', this.resize, opts);
      window.addEventListener('pageshow', this.resize, opts);
      this.motion.addEventListener('change', this.resize, opts);
      this.addEventListener('load', this.resize, { ...opts, capture: true });

      this.observer = new ResizeObserver(this.resize);
      const contentElement = this.querySelector('.dms__content');
      if (contentElement) this.observer.observe(contentElement);
      // Do not observe cards: pinning changes their height and can cause a resize loop.
      // Do not observe the wordmark itself; its own layout changes do not need
      // to trigger a re-measure of the pinned scroll stage.

      document.addEventListener('shopify:section:reorder', this.resize, opts);
      document.fonts?.ready.then(() => { if (this.isConnected && !this.abort?.signal.aborted) this.resize(); });
      this.measure();
      this.syncVideos();
    }

    setupVideos(opts) {
      this.videoActive = 0;
      this.videoInView = false;
      this.cardVideos = this.cards.map(card => card.querySelector('video'));
      this.playStates = new Map();
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.canAutoPlay = video => {
        const state = this.playStates.get(video);
        return this.isConnected && !!this.abort && !this.abort.signal.aborted &&
          state?.active && !state.manualPause && !document.hidden &&
          !this.reducedMotion.matches;
      };
      this.schedulePlay = video => {
        const state = this.playStates.get(video);
        if (!state || state.timer || state.retries >= 3 || !this.canAutoPlay(video)) return;
        state.retries += 1;
        state.timer = setTimeout(() => {
          state.timer = null;
          this.tryPlay(video);
        }, 350 * state.retries);
      };
      this.tryPlay = video => {
        const state = this.playStates.get(video);
        if (!state || state.pending || !video.paused || video.ended || !this.canAutoPlay(video)) return;
        state.pending = true;
        video.preload = 'auto';
        video.muted = true;
        video.playsInline = true;
        let request;
        try { request = video.play(); } catch (error) { request = Promise.reject(error); }
        Promise.resolve(request).then(() => {
          if (!this.canAutoPlay(video)) video.pause();
          else state.retries = 0;
        }).catch(() => {
          this.schedulePlay(video);
        }).finally(() => {
          state.pending = false;
          if (video.paused && !video.ended && this.canAutoPlay(video)) this.schedulePlay(video);
        });
      };

      this.cardVideos.forEach(video => {
        if (!video) return;

        video.controls = false;
        video.autoplay = false;
        video.muted = true;
        video.playsInline = true;
        video.pause();
        video.dataset.active = 'false';
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        this.playStates.set(video, { active: false, pending: false, manualPause: false, retries: 0, timer: null });
        const retryWhenReady = () => {
          const state = this.playStates.get(video);
          state.retries = 0;
          this.tryPlay(video);
        };
        video.addEventListener('loadeddata', retryWhenReady, opts);
        video.addEventListener('canplay', retryWhenReady, opts);
        video.addEventListener('pause', () => this.schedulePlay(video), opts);
        video.tabIndex = 0;
        video.setAttribute('role', 'button');

        const updateLabel = () => {
          video.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        };

        updateLabel();
        video.addEventListener('play', updateLabel, opts);
        video.addEventListener('pause', updateLabel, opts);

        const toggle = () => {
          const state = this.playStates.get(video);
          if (video.paused) {
            state.manualPause = false;
            state.retries = 0;
            video.play().catch(() => this.schedulePlay(video));
          } else {
            state.manualPause = true;
            clearTimeout(state.timer);
            state.timer = null;
            video.pause();
          }
        };

        video.addEventListener('click', toggle, opts);
        video.addEventListener('keydown', event => {
          if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            toggle();
          }
        }, opts);
      });

      this.querySelectorAll('.dh-freeze').forEach(video => {
        video.controls = false;
        video.muted = true;
        video.autoplay = false;
        video.loop = false;
        video.pause();
        video.tabIndex = -1;

        const freeze = () => {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          const target = Math.max(0, video.duration - 1);
          if (Math.abs(video.currentTime - target) > 0.06) {
            try { video.currentTime = target; } catch (error) {}
          }
          video.pause();
        };

        video.addEventListener('loadedmetadata', freeze, opts);
        video.addEventListener('durationchange', freeze, opts);
        video.addEventListener('loadeddata', freeze, opts);
        video.addEventListener('seeked', () => video.pause(), opts);
        video.addEventListener('play', freeze, opts);
        freeze();
      });

      this.syncVideos = () => {
        this.cardVideos.forEach((video, index) => {
          if (!video) return;

          const active =
            this.videoInView &&
            !document.hidden &&
            index === this.videoActive;

          const state = this.playStates.get(video);
          const wasActive = state.active;
          state.active = active;
          video.dataset.active = String(active);
          if (this.videoInView && index <= Math.max(0, this.videoActive) + 1) video.preload = 'auto';
          if (!active) {
            clearTimeout(state.timer);
            state.timer = null;
            state.manualPause = false;
            if (!video.paused) video.pause();
          } else {
            if (!wasActive) {
              state.retries = 0;
              state.manualPause = false;
            }
            this.tryPlay(video);
          }
        });
      };

      document.addEventListener('visibilitychange', this.syncVideos, opts);
      this.reducedMotion.addEventListener('change', this.syncVideos, opts);
      window.addEventListener('pageshow', this.syncVideos, opts);
      const retryAfterGesture = () => {
        this.cardVideos.forEach(video => {
          const state = this.playStates.get(video);
          if (!state || state.manualPause) return;
          state.retries = 0;
          this.tryPlay(video);
        });
      };
      document.addEventListener('pointerup', retryAfterGesture, opts);
      document.addEventListener('keydown', retryAfterGesture, opts);

      if (typeof IntersectionObserver !== 'undefined') {
        this.videoObserver = new IntersectionObserver(entries => {
          if (!this.hasAttribute('data-pinned')) return;
          this.videoInView = entries.some(entry => entry.isIntersecting);
          this.syncVideos();
        }, { threshold: 0.15 });

        this.videoObserver.observe(this.grid);
        this.visibleCards = new Map();
        this.cardObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => this.visibleCards.set(entry.target, entry.intersectionRatio));
          if (this.hasAttribute('data-pinned')) return;
          const visible = this.cards.map((card,index) => ({index,ratio:this.visibleCards.get(card)||0})).sort((a,b)=>b.ratio-a.ratio)[0];
          this.videoActive = visible && visible.ratio > 0 ? visible.index : -1;
          this.videoInView = this.videoActive >= 0;
          this.syncVideos();
        }, {threshold:[0,.1,.25,.5,.75,1]});
        this.cards.forEach(card => this.cardObserver.observe(card));
      } else {
        this.videoInView = true;
      }
    }


    setupSwipeControls(opts) {
      const rail = this.querySelector('.dh-comparison-rail');
      if (!rail) return;
      const figures = [...rail.querySelectorAll('.dh-figure')];
      this.querySelector('.dh-swipe-controls')?.remove();
      if (figures.length < 2) return;
      const controls = document.createElement('div');
      controls.className = 'dh-swipe-controls';
      const chinese = document.documentElement.lang.toLowerCase().startsWith('zh');
      const count = document.createElement('span');
      count.className = 'dh-swipe-count';
      count.setAttribute('aria-live', 'polite');
      count.setAttribute('aria-atomic', 'true');
      const dots = document.createElement('div');
      dots.className = 'dh-swipe-dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', chinese ? '选择卡片' : 'Choose a card');
      const hint = document.createElement('span');
      hint.className = 'dh-swipe-hint';
      const gesture = document.createElement('span');
      gesture.className = 'dh-swipe-gesture';
      gesture.setAttribute('aria-hidden', 'true');
      hint.append(gesture, document.createTextNode(chinese ? '左右滑动' : 'Swipe to explore'));
      const buttons = figures.map((figure, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dh-swipe-dot';
        button.setAttribute('aria-label', chinese ? '查看第 ' + (index + 1) + ' 张卡片' : 'View card ' + (index + 1) + ' of ' + figures.length);
        button.addEventListener('click', () => {
          controls.classList.add('is-used');
          const delta = figure.getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({left:rail.scrollLeft + delta, behavior:this.motion.matches ? 'smooth' : 'auto'});
        }, opts);
        dots.append(button);
        return button;
      });
      controls.append(count, dots, hint);
      rail.after(controls);
      const update = () => {
        this.swipeFrame = null;
        const edge = rail.getBoundingClientRect().left;
        let active = 0;
        figures.forEach((figure, index) => {
          if (Math.abs(figure.getBoundingClientRect().left - edge) < Math.abs(figures[active].getBoundingClientRect().left - edge)) active = index;
        });
        const text = (active + 1) + ' / ' + figures.length;
        if (count.textContent !== text) count.textContent = text;
        buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
        if (active > 0) controls.classList.add('is-used');
      };
      const schedule = () => {
        if (this.swipeFrame == null) this.swipeFrame = requestAnimationFrame(update);
      };
      rail.addEventListener('scroll', schedule, {...opts, passive:true});
      window.addEventListener('resize', schedule, {...opts, passive:true});
      rail.addEventListener('pointerdown', () => controls.classList.add('is-used'), {...opts, passive:true});
      this.swipeObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => controls.classList.toggle('is-in-view', entry.isIntersecting));
      }, {threshold:.5});
      this.swipeObserver.observe(controls);
      update();
    }

    disconnectedCallback() {
      this.swipeObserver?.disconnect();
      cancelAnimationFrame(this.swipeFrame);
      this.swipeFrame = null;
      // Restore original DOM location before a theme-editor reconnect.
      if (this.compareHome?.parentNode && this.compare) this.compareHome.after(this.compare);
      this.compareHome?.remove();
      this.videoObserver?.disconnect();
      this.cardObserver?.disconnect();
      this.playStates?.forEach(state => {
        state.active = false;
        clearTimeout(state.timer);
      });
      this.querySelectorAll('video').forEach(video => video.pause());
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.staticFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domitree-press-reveal"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('domitree-press-reveal')){
class DomiTreePressReveal extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.viewport=this.querySelector('.pr-viewport');this.track=this.querySelector('.pr-track');this.group=this.querySelector('.pr-group');this.toggle=this.querySelector('.pr-toggle');
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.desktop=matchMedia('(min-width:750px) and (hover:hover)');
  this.touching=false;this.interacting=false;this.pointerFocus=false;this.paused=false;this.hovered=false;this.focused=false;this.visible=true;this.velocity=0;this.last=0;
  const readyImages=()=>this.querySelectorAll('.pr-hover img').forEach(img=>{const ready=()=>{if(img.naturalWidth)img.closest('.pr-card').classList.add('is-ready')};if(img.complete)ready();else img.addEventListener('load',ready,{once:true,signal:this.abort.signal})});
  this.build=()=>{
   this.track.querySelectorAll('[data-copy]').forEach(e=>e.remove());this.style.setProperty('--pr-screen',this.viewport.clientWidth+'px');
   this.enabled=this.dataset.auto==='true'&&!this.motion.matches&&this.group.children.length>0;
   if(this.enabled){const clone=this.group.cloneNode(true);clone.dataset.copy='';clone.setAttribute('aria-hidden','true');clone.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));clone.querySelectorAll('a,button').forEach(e=>e.tabIndex=-1);this.track.append(clone)}
   this.distance=this.group.getBoundingClientRect().width;this.viewport.scrollLeft=0;this.position=0;this.velocity=0;
   if(this.toggle)this.toggle.hidden=!this.enabled;readyImages();this.start();
  };
  this.viewport.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true},options);
  this.viewport.addEventListener('pointerleave',()=>{this.hovered=false;this.start()},options);
  this.viewport.addEventListener('focusin',e=>{this.focused=!this.pointerFocus&&e.target.matches(':focus-visible');if(this.focused)this.velocity=0},options);
  this.viewport.addEventListener('focusout',e=>{if(!this.viewport.contains(e.relatedTarget)){this.focused=false;this.position=this.viewport.scrollLeft;this.start()}},options);
  this.addEventListener('click',e=>{const card=e.target.closest('.pr-card');if(!card)return;if(card.tagName==='BUTTON'||!this.desktop.matches){const active=card.classList.contains('is-active');if(card.tagName==='A'&&active)return;e.preventDefault();this.querySelectorAll('.pr-card.is-active').forEach(c=>{c.classList.remove('is-active');if(c.tagName==='BUTTON')c.setAttribute('aria-pressed','false')});if(!active){card.classList.add('is-active');if(card.tagName==='BUTTON')card.setAttribute('aria-pressed','true')}}},options);
  this.settle=()=>{clearTimeout(this.resumeTimer);if(this.touching)return;this.resumeTimer=setTimeout(()=>{this.interacting=false;this.position=this.viewport.scrollLeft;this.start()},450)};
  this.viewport.addEventListener('pointerdown',e=>{this.pointerFocus=true;if(e.pointerType!=='mouse'){this.touching=true;this.interacting=true;this.velocity=0;clearTimeout(this.resumeTimer)}},options);
  window.addEventListener('pointerup',()=>{if(this.touching){this.touching=false;this.settle()}},options);
  window.addEventListener('pointercancel',()=>{if(this.touching){this.touching=false;this.settle()}},options);
  this.viewport.addEventListener('scroll',()=>{if(this.interacting)this.settle()}, {passive:true,signal:this.abort.signal});
  this.viewport.addEventListener('keydown',()=>{this.pointerFocus=false;this.focused=true;this.velocity=0},options);
  this.viewport.addEventListener('wheel',e=>{if(Math.abs(e.deltaX)>0||e.shiftKey){this.interacting=true;this.velocity=0;this.settle()}}, {passive:true,signal:this.abort.signal});
  if(this.toggle)this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.position=this.viewport.scrollLeft;this.updateToggle();this.start()},options);
  this.motion.addEventListener('change',this.build,options);this.desktop.addEventListener('change',this.build,options);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(this.frame);this.frame=0}else this.start()},options);
  this.addEventListener('shopify:block:select',e=>{this.paused=true;this.updateToggle();const item=e.target.closest('.pr-item');if(item)this.viewport.scrollLeft=item.offsetLeft;},options);
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.start();else{cancelAnimationFrame(this.frame);this.frame=0}},{rootMargin:'80px'});this.observer.observe(this);
  this.resize=new ResizeObserver(()=>{const w=this.viewport.clientWidth;if(w!==this.lastWidth){this.lastWidth=w;this.build()}});this.resize.observe(this.viewport);this.build();
 }
 updateToggle(){if(this.toggle){this.toggle.setAttribute('aria-pressed',String(this.paused));this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel)}}
 start(){if(this.frame||!this.enabled||!this.visible||document.hidden)return;this.last=0;this.frame=requestAnimationFrame(t=>this.tick(t))}
 tick(t){
  this.frame=0;if(!this.isConnected||!this.enabled||!this.visible||document.hidden)return;
  const dt=this.last?Math.min((t-this.last)/1000,.05):0;this.last=t;
  const target=this.paused||this.hovered||this.focused||this.interacting?0:Number(this.dataset.speed)||22;
  this.velocity+=(target-this.velocity)*(1-Math.exp(-dt*12));
  if(!this.focused&&!this.interacting&&this.velocity>.02&&this.distance>0){this.position=(this.position+this.velocity*dt)%this.distance;this.viewport.scrollLeft=this.position}
  if(target===0&&this.velocity<.02){this.velocity=0;return}
  this.frame=requestAnimationFrame(n=>this.tick(n));
 }
 disconnectedCallback(){clearTimeout(this.resumeTimer);this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=0}
}
customElements.define('domitree-press-reveal',DomiTreePressReveal);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-carousel-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-carousel-video-pro')) {
    customElements.define('feature-carousel-video-pro', class extends HTMLElement {
      connectedCallback() {
        this.syncViewport = () => this.style.setProperty('--sfc-viewport', document.documentElement.clientWidth + 'px');
        this.syncViewport();
        window.addEventListener('resize', this.syncViewport, { passive: true });
        this.viewportResize = new ResizeObserver(this.syncViewport);
        this.viewportResize.observe(document.documentElement);
        this.mountFrame = requestAnimationFrame(() => this.mount());
      }
      mount() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('[data-sfc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-sfc-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.index = 0; this.pending = null; this.hovered = false; this.focused = false; this.drag = null;
        this.loop = this.dataset.loop === 'true';
        this.editor = this.dataset.editor === 'true';
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.editor;
        this.inView = !('IntersectionObserver' in window);
        this.videos = Array.from(this.querySelectorAll('.sfc__video'));
        this.videos.forEach(video => {
          video.dataset.active = 'false';
          if (!video.controls) {
            video.tabIndex = 0;
            video.setAttribute('role', 'button');
            const label = () => video.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
            const toggle = () => { if(video.paused) video.play().catch(() => {}); else video.pause(); };
            video.addEventListener('click', toggle, opts);
            video.addEventListener('keydown', event => { if(event.key === ' ' || event.key === 'Enter'){event.preventDefault();event.stopPropagation();toggle();} }, opts);
            video.addEventListener('play', label, opts);video.addEventListener('pause', label, opts);label();
          }
        });
        this.pages = Array.from(this.querySelectorAll('[data-sfc-page]'));
        this.prev = this.querySelector('[data-sfc-prev]');
        this.next = this.querySelector('[data-sfc-next]');
        this.play = this.querySelector('[data-sfc-play]');
        this.status = this.querySelector('[data-sfc-status]');
        this.querySelectorAll('[data-sfc-controls], [data-sfc-prev], [data-sfc-next]').forEach(el => { el.hidden = false; });
        this.prev?.addEventListener('click', () => this.go((this.pending ?? this.index) - 1), opts);
        this.next?.addEventListener('click', () => this.go((this.pending ?? this.index) + 1), opts);
        this.pages.forEach((button, i) => button.addEventListener('click', () => this.go(i), opts));
        this.play?.addEventListener('click', () => { this.paused = !this.paused; this.update(); this.schedule(); }, opts);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 140);
        }, { ...opts, passive: true });
        this.track.addEventListener('scrollend', () => this.settle(), opts);
        this.track.addEventListener('pointerdown', event => {
          clearTimeout(this.timer); this.pending = null;
          if (event.pointerType !== 'mouse' || this.dataset.mouseDrag !== 'true' || event.button !== 0 || event.target.closest('[data-sfc-text],a,button,video')) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft };
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
        }, opts);
        this.track.addEventListener('pointermove', event => {
          if (this.drag?.id === event.pointerId) this.track.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        }, opts);
        const release = event => {
          if (this.drag?.id === event.pointerId) {
            this.drag = null;
            this.track.classList.remove('is-dragging');
            if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
            this.go(this.nearest());
          } else this.schedule();
        };
        this.track.addEventListener('pointerup', release, opts);
        this.track.addEventListener('pointercancel', release, opts);
        this.track.addEventListener('lostpointercapture', release, opts);
        this.addEventListener('keydown', event => {
          if (event.target.closest('input,textarea,select,video,[contenteditable=true]') || event.altKey || event.metaKey || event.ctrlKey) return;
          const current = this.pending ?? this.index;
          const keys = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: this.slides.length - 1 };
          if (keys[event.key] === undefined) return;
          event.preventDefault(); this.go(keys[event.key]);
        }, opts);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, opts);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, opts);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, opts);
        document.addEventListener('visibilitychange', () => this.schedule(), opts);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.update(); this.schedule(); }, opts);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.paused = true;
          const node = event.target.closest('[data-slide-target], [data-sfc-slide]');
          if (node?.hasAttribute('data-slide-target')) {
            const target = Number(node.dataset.slideTarget);
            if (target >= 1 && target <= this.slides.length) this.go(target - 1, true);
          } else if (node?.hasAttribute('data-slide-index')) this.go(Number(node.dataset.slideIndex), true);
          this.update(); this.schedule();
        }, opts);
        this.resize = new ResizeObserver(() => { this.go(this.pending ?? this.index, true); });
        this.resize.observe(this.track);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { this.inView = entries.some(e => e.isIntersecting); this.schedule(); }, { threshold: 0.2 });
          this.observer.observe(this);
        }
        this.go(0, true);
      }
      nearest() { return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)))); }
      go(target, instant = false) {
        const count = this.slides.length;
        target = this.loop ? ((target % count) + count) % count : Math.max(0, Math.min(count - 1, target));
        this.pending = target; this.index = target; this.update(); clearTimeout(this.timer);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 180);
      }
      settle() {
        clearTimeout(this.settleTimer);
        if (this.drag) return;
        this.index = this.nearest(); this.pending = null; this.update(); this.schedule();
      }
      update() {
        this.syncVideos();
        this.pages.forEach((button, i) => { if (i === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
        if (this.prev) this.prev.disabled = !this.loop && this.index === 0;
        if (this.next) this.next.disabled = !this.loop && this.index === this.slides.length - 1;
        const activeSlide = this.slides[this.index];
        this.dataset.activeTransparent = String(!activeSlide || activeSlide.dataset.hasBackground !== 'true');
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          if (this.editor) return;
          slide.inert = i !== this.index;
          slide.setAttribute('aria-hidden', String(i !== this.index));
        });
        this.toggleAttribute('data-paused', this.paused);
        if (this.play) this.play.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.status) { this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off'); this.status.textContent = (this.index + 1) + ' / ' + this.slides.length; }
      }
      schedule() {
        this.syncVideos();
        clearTimeout(this.timer);
        if (this.paused || this.editor || this.hovered || this.focused || this.drag || !this.inView || document.hidden || this.slides.length < 2) return;
        if (!this.loop && this.index === this.slides.length - 1) { this.paused = true; this.update(); return; }
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3000, Number(this.dataset.interval) * 1000 || 6000));
      }
      syncVideos() {
        (this.videos || []).forEach(video => {
          const active = video.closest('[data-sfc-slide]') === this.slides[this.index] && this.inView && !document.hidden;
          const wasActive = video.dataset.active === 'true';
          video.dataset.active = String(active);
          if (!active) { if(!video.paused) video.pause(); return; }
          if (!wasActive && video.parentElement.dataset.videoAutoplay === 'true' && !this.motion.matches) {
            video.muted = true;
            video.play().catch(() => {});
          }
        });
      }
      disconnectedCallback() {
        (this.videos || []).forEach(video => { video.pause(); video.dataset.active = 'false'; });
        window.removeEventListener('resize', this.syncViewport);
        this.viewportResize?.disconnect();
        cancelAnimationFrame(this.mountFrame); clearTimeout(this.timer); clearTimeout(this.settleTimer);
        this.controller?.abort(); this.controller = null; this.resize?.disconnect(); this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-horizontal-trio"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('story-horizontal-trio'))customElements.define('story-horizontal-trio',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.stage=this.querySelector('.sh-stage');this.pin=this.querySelector('.sh-pin');this.track=this.querySelector('.sh-track');this.intro=this.querySelector('.sh-intro');this.gallery=this.querySelector('.sh-window');
  this.media=matchMedia('(min-width:750px) and (prefers-reduced-motion:no-preference)');
  this.update=()=>{if(!this.hasAttribute('data-motion'))return;const top=parseFloat(getComputedStyle(this).getPropertyValue('--sh-top'))||0;const distance=Math.max(1,this.stage.offsetHeight-this.pin.offsetHeight);const progress=Math.max(0,Math.min(1,(top-this.stage.getBoundingClientRect().top)/distance));const chosen=this.selected;const p=chosen?(chosen.classList.contains('sh-text')?0:1):progress;this.style.setProperty('--sh-shift',(-this.travel*p)+'px');};
  this.measure=()=>{this.style.removeProperty('--sh-view');this.style.removeProperty('--sh-offset');const left=this.getBoundingClientRect().left;this.style.setProperty('--sh-view',document.documentElement.clientWidth+'px');this.style.setProperty('--sh-offset',-left+'px');this.toggleAttribute('data-motion',this.media.matches);const gap=parseFloat(getComputedStyle(this.track).gap)||0;this.travel=this.intro.offsetWidth+gap;this.update();};
  this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=null;this.update();});};
  this.resize=()=>{if(this.resizeFrame)return;this.resizeFrame=requestAnimationFrame(()=>{this.resizeFrame=null;this.measure();});};
  window.addEventListener('scroll',this.schedule,{...opts,passive:true});window.addEventListener('resize',this.resize,opts);window.addEventListener('pageshow',this.resize,opts);this.media.addEventListener('change',this.resize,opts);
  this.addEventListener('shopify:block:select',e=>{this.selected=e.target.closest('.sh-text,.sh-card');this.update();if(!this.hasAttribute('data-motion')&&this.selected?.classList.contains('sh-card'))this.selected.scrollIntoView({block:'nearest',inline:'nearest'});},opts);
  this.addEventListener('shopify:block:deselect',()=>{this.selected=null;this.update();},opts);
  this.gallery.addEventListener('focusin',e=>{if(!this.hasAttribute('data-motion')||!e.target.closest('.sh-card'))return;const top=parseFloat(getComputedStyle(this).getPropertyValue('--sh-top'))||0;window.scrollTo({top:window.scrollY+this.stage.getBoundingClientRect().top-top+this.stage.offsetHeight-this.pin.offsetHeight,behavior:'auto'});this.gallery.scrollLeft=0;},opts);
  this.gallery.addEventListener('keydown',e=>{if(e.target!==this.gallery||!this.hasAttribute('data-motion'))return;if(!['ArrowRight','ArrowLeft','Home','End'].includes(e.key))return;e.preventDefault();const top=parseFloat(getComputedStyle(this).getPropertyValue('--sh-top'))||0;const start=window.scrollY+this.stage.getBoundingClientRect().top-top;const end=start+this.stage.offsetHeight-this.pin.offsetHeight;const target=e.key==='Home'?start:e.key==='End'?end:window.scrollY+(e.key==='ArrowRight'?1:-1)*(end-start)/3;window.scrollTo({top:Math.max(start,Math.min(end,target)),behavior:'auto'});},opts);
  if(typeof ResizeObserver!=='undefined'){this.observer=new ResizeObserver(this.resize);this.observer.observe(document.documentElement);if(this.parentElement)this.observer.observe(this.parentElement);}
  this.measure();
  this.setupPagination(opts);
 }

 setupPagination(opts){
  const rail=this.querySelector('.sh-images');
  const cards=[...rail.querySelectorAll('.sh-card')];
  this.querySelector('.sh-pagination')?.remove();
  this.removeAttribute('data-pagination');
  if(cards.length<2)return;
  const nav=document.createElement('div');nav.className='sh-pagination';nav.setAttribute('role','group');nav.setAttribute('aria-label','Choose image');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const buttons=cards.map((card,index)=>{
   const button=document.createElement('button');button.type='button';button.className='sh-page';
   button.setAttribute('aria-label','View image '+(index+1)+' of '+cards.length);
   button.addEventListener('click',()=>{
    const delta=card.getBoundingClientRect().left-rail.getBoundingClientRect().left;
    rail.scrollTo({left:rail.scrollLeft+delta,behavior:reduced.matches?'auto':'smooth'});
   },opts);
   nav.append(button);return button;
  });
  rail.after(nav);this.setAttribute('data-pagination','');
  const update=()=>{
   this.paginationFrame=null;
   const bounds=rail.getBoundingClientRect();const center=(bounds.left+bounds.right)/2;
   let active=0,best=Infinity;
   cards.forEach((card,index)=>{const rect=card.getBoundingClientRect();const distance=Math.abs((rect.left+rect.right)/2-center);if(distance<best){best=distance;active=index;}});
   buttons.forEach((button,index)=>button.setAttribute('aria-current',String(index===active)));
  };
  const schedule=()=>{if(this.paginationFrame==null)this.paginationFrame=requestAnimationFrame(update);};
  rail.addEventListener('scroll',schedule,{...opts,passive:true});
  window.addEventListener('resize',schedule,{...opts,passive:true});
  update();
 }

 disconnectedCallback(){cancelAnimationFrame(this.paginationFrame);this.paginationFrame=null;this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);cancelAnimationFrame(this.resizeFrame);this.abort=null;this.frame=null;this.resizeFrame=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-specifications-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('technical-specs-panel')) {
    customElements.define('technical-specs-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.editor !== 'true' || this.editorController) return;
        this.editorController = new AbortController();
        this.addEventListener('shopify:block:select', () => {
          const details = this.querySelector('details');
          if (details) details.open = true;
        }, { signal: this.editorController.signal });
      }
      disconnectedCallback() {
        if (this.editorController) this.editorController.abort();
        this.editorController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
